import { parse as parseDate } from 'date-fns';

import { Pill } from '../../../../../../../components/Clickables/Pill/Pill';
import { Heading } from '../../../../../../../components/Heading/Heading';
import { useMapLayers } from '@domain/map/MapLayersContext';
import { useIsTabletScreenWidthOrThinner } from '@hooks/useScreenWidth';
import { useUserInfo } from '@domain/user/useUserInfo';
import { MonthEnum } from '../../../../../../../generated/graphql';
import { useExplore } from '../../../../../context/ExploreContext';
import { convertMonthArrayForUrl, getMonthArrayFromUrl } from '../../../../../context/helpers';
import { capitalizeString } from '@lib/strings/capitalizeString';

export const FilterByMonth = () => {
  const isTabletScreenWidthOrThinner = useIsTabletScreenWidthOrThinner();
  const { toggleLayer, layers } = useMapLayers();
  const { isWholeLayerVisible } = layers.catchPositions;
  const { isPremium } = useUserInfo();

  const { exploreQueryParams, saveParamsInUrl } = useExplore();
  const { catchFiltersMonths } = exploreQueryParams;
  const catchesFilterMonthArray = getMonthArrayFromUrl(catchFiltersMonths);

  const sortedMonths = Object.values(MonthEnum).sort(
    (a, b) =>
      parseDate(a, 'MMMM', new Date()).getMonth() - parseDate(b, 'MMMM', new Date()).getMonth(),
  );

  return (
    <div>
      <Heading variant="2xs" className="mb-5">
        Filter by month
      </Heading>
      <div className="grid max-w-lg grid-cols-4 gap-1">
        {sortedMonths.map(month => {
          const isActive = catchesFilterMonthArray.includes(month);
          return (
            <Pill
              size={isTabletScreenWidthOrThinner ? 'lg' : 'sm'}
              variant="lakeFogBg"
              key={month}
              isActive={isActive}
              onClick={() => {
                if (!isWholeLayerVisible && isPremium) {
                  toggleLayer('catchPositions');
                }
                const newState = isActive
                  ? catchesFilterMonthArray.filter(value => value !== month)
                  : [...catchesFilterMonthArray, month];

                saveParamsInUrl({
                  catchFiltersMonths: convertMonthArrayForUrl(newState),
                });
              }}
            >
              {capitalizeString(month.substring(0, 3).toLowerCase())}
            </Pill>
          );
        })}
      </div>
    </div>
  );
};
